import { motion } from "framer-motion";
import BannerImg from "../../assets/image_3.png";

export default function WhyWeDoIt() {
    return (
        <section className="px-4 my-10 md:my-32">
            <div className="max-w-7xl mx-auto gap-8 grid grid-cols-1 md:grid-cols-2">
                {/* Left Section */}
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="flex flex-col justify-center"
                >
                    <h2 className="text-2xl md:text-4xl font-bold mb-2 md:mb-6 text-headings">Why We Do It</h2>
                    <p className="text-sm md:text-lg max-w-[500px] text-light_black">
                        Tuber was born out of necessity. Our founders have worked in Australian trades for over 20
                        years and experienced the daily frustration of leaving job sites to pick up materials. The
                        back-and-forth wasted valuable hours, disrupted workflows, and delayed projects. <br /> <br />
                        No one else specialised in commercial deliveries or had the vehicles to get the job done
                        right—so we built Tuber. Now, we’re revolutionising trade logistics.
                    </p>
                </motion.div>

                {/* Right Section (Image) */}
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.3 }}
                    viewport={{ once: true }}
                    className="relative w-full h-full"
                >
                    <img
                        src={BannerImg}
                        alt="Image 3"
                        className="object-cover w-full h-full rounded-xl"
                    />
                </motion.div>

            </div>
        </section>
    );
}
